import * as Yup from "yup";

export const validationSchema = Yup.object({
  companyName: Yup.string().required("Company name is required"),
  companySize: Yup.string().required("Company size is required"),
  industry: Yup.string().required("Industry is required"),
});
